<template>
  <v-expansion-panel class="my-1">
    <load-item-header :load="load" :totalPallets="totalBreakdowns" :totals="totals" />
    <v-expansion-panel-content>
      <load-pallet-header :palletBreakdownHeader="palletBreakdownHeader" />
      <load-pallet-breakdowns
        :palletBreakdowns="breakdowns"
        :palletBreakdownHeader="palletBreakdownHeader"
        :load="load"
        v-if="breakdowns && breakdowns.length"
      />
      <strong class="red--text" v-else>No Pallets Available!</strong>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import LoadItemHeader from './LoadItemHeader';
import LoadPalletHeader from './LoadPalletHeader';
import LoadPalletBreakdowns from './LoadPalletBreakdowns';

export default {
  name: 'LoadItem',
  computed: {
    breakdowns() {
      return this.load.palletBreakdowns;
    },
    totalBreakdowns() {
      return this.breakdowns.length;
    },
    totals() {
      const lBreakdowns = this.breakdowns.filter(b => b.pallet_loaded === 'Loaded');
      const loadedLength = lBreakdowns.length;
      return {
        totalLoaded: loadedLength,
        totalUnLoaded: this.totalBreakdowns - loadedLength
      };
    },
    palletBreakdownHeader() {
      return this.load.palletBreakdownHeader;
    }
  },
  props: ['load'],
  components: { LoadItemHeader, LoadPalletHeader, LoadPalletBreakdowns }
};
</script>

<style lang="scss">
.v-expansion-panels--popout > .v-expansion-panel {
  max-width: unset !important;
}
</style>